import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {SettingsIncidentReport} from '../types/models';
import {filter, tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class SettingsIncidentReportService {
    data = {
        allIncidentReportsSettings: {
            get: '/v1/amenity?expand=buildingAmenity,createdBy,fees,disabledDates,staffNotificationSettings,staffNotificationSettings.userRoles,residentsNotificationSettings',
            data: [],
            total: null
        },
    };
    showCreateModal = false;
    isNotificationModalShow = false;
    showDetailedView = false;
    selectedItemData: SettingsIncidentReport;
    spinnerShow = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    corporations: any = {
        data: [],
        total: null
    };
    buldingsInMultiselectFormat: Array<any> = [];
    selectedItemFormattedBuildingsArray: Array<any> = [];
    modalSpinnerShow = false;
    showServiceUnavailable = false;
    serviceName: string = 'inc_report';
    userRoles: Array<any> = [];
    createdStaffMultiselectArray: Array<any> = [];
    modifiedStaffMultiselectArray: Array<any> = [];
    deletedStaffMultiselectArray: Array<any> = [];
    requestCreatedStaffCheckbox = false;
    requestModifiedStaffCheckbox = false;
    requestDeletedStaffCheckbox = false;
    notificationModalStaffOrResident = '';
    notificationModalNotificationType = '';

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?per-page=1000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            (res) => {
                this.buildings = JSON.parse(res._body).entities;
                this.getFilteredBuildings();
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    getCorporations(scrollToTop?): void {
        this.showServiceUnavailable = false;
        this.spinnerShow = true;
        let queryParams = this.urlService.getQueryParamsString();
        if (queryParams && queryParams.indexOf('&order-by=') != -1)
            queryParams = queryParams.slice(0, queryParams.indexOf('&order-by='));
        const url = `/v1/corporation_number.json?${queryParams}`;
        this.api.get('domainBD', url).subscribe(
            (res) => {
                this.corporations.data = JSON.parse(res._body).entities;
                this.corporations.total = JSON.parse(res._body).total;
                this.emptyRowService.fillEmptyRow();
                if ($('.table')[0] && scrollToTop)
                    $('.table')[0].scrollIntoView();
            },
            (error) => {
                this.showServiceUnavailable = true;
                this.spinnerShow = false;
                this.api.errorHandler(error, 'Failed get corporations');
            },
            () => this.spinnerShow = false
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data.allIncidentReportsSettings.data = [];
            this.data.allIncidentReportsSettings.total = null;
        }
    }

    toggleDetailedView(data, state: boolean): void {
        this.data.allIncidentReportsSettings.data.forEach(item => item.checked = false);
        this.emptyNotificationArrays();
        this.selectedItemData = data ? data : null;
        this.showDetailedView = state;
        if (this.selectedItemData) {
            this.selectedItemData.checked = true;
            this.formatNotificationSettingsRoles();
        }
    }

    canEdit(buildingId?: number) {
        return this.account.canSetup(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canSetup(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
        this.buldingsInMultiselectFormat = this.getBuildingsInProperFormat(this.buildings);
    }

    getBuildingsInProperFormat(arr: Array<any>) {
        return arr.map(building => ({id: parseInt(building.id), itemName: building.name}));
    }

    public getUserRoles() {
        const url = `/api/v1/role.json`;
        this.api.getInfiniteList('oauthUrl', url, 1000).subscribe(
            res => {
                this.userRoles = res.entities.map(role => ({id: role.id, itemName: role.name}));
            },
            error => this.api.errorHandler(error, 'Failed get Roles')
        );
    }

    public formatNotificationSettingsRoles(): any {
        if (this.selectedItemData) {
            this.selectedItemData.staffNotificationSettings.forEach(notificationSetting => {
                let actionPart = '';
                if (notificationSetting.action == 'report_created')
                    actionPart = 'Created';
                else if (notificationSetting.action == 'report_updated')
                    actionPart = 'Modified';
                else if (notificationSetting.action == 'report_deleted')
                    actionPart = 'Deleted';
                this['request' + actionPart + 'StaffCheckbox'] = notificationSetting.active;
                notificationSetting.roles.forEach(role => {
                    this[actionPart.toLowerCase() + 'StaffMultiselectArray'].push({
                        id: role.bdId,
                        itemName: role.name
                    });
                });
            });
        }
    }

    emptyNotificationArrays(): void {
        this.createdStaffMultiselectArray = [];
        this.modifiedStaffMultiselectArray = [];
        this.deletedStaffMultiselectArray = [];
        this.requestCreatedStaffCheckbox = false;
        this.requestModifiedStaffCheckbox = false;
        this.requestDeletedStaffCheckbox = false;
    }

    getData(scrollToTop?) {
        this.getDataByQueryParams(scrollToTop).subscribe();
    }

    getDataByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        this.data.allIncidentReportsSettings.total = null;

        const url = '/v1/settings.json?';
        const queryParams = this.urlService.getQueryParamsString();

        return this.api.getJson('domainIncidentReports', `${url}${queryParams}`)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity((item) => {
                    if (item.building && item.building.bdId) {
                        item.building.id = item.building.bdId;
                    }
                    return SettingsIncidentReport.fromExistingData(this.account.addPermissionsToEntity(item, this.serviceName));
                }),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    (res) => {
                        this.data.allIncidentReportsSettings.data = res.entities;
                        this.data.allIncidentReportsSettings.total = res.total;
                        this.emptyRowService.fillEmptyRow();
                        this.emptyNotificationArrays();
                        if ($('.table')[0] && scrollToTop)
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, `Failed to get Service Request Rules`);
                    }
                ),
                filter(({finished}) => finished),
                tap(() => {
                    if (this.selectedItemData) {
                        this.selectedItemData = this.data.allIncidentReportsSettings.data.find(si => si.id == this.selectedItemData.id);
                        if (this.selectedItemData)
                            this.selectedItemData.checked = true;
                        else
                            this.showDetailedView = false;
                        this.formatNotificationSettingsRoles();
                    }
                })
            );
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/settings-incident-report.service.ts